import React from "react";
import { useLanguage } from "../context/LanguageContext";

const Footer = () => {
  const { translateHTML, translate } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: "smooth",
      });
    }
  };

  const servicesLinks = [
    { id: "service1-title", section: "services" },
    { id: "service2-title", section: "services" },
    { id: "service3-title", section: "services" },
    { id: "service4-title", section: "services" },
    { id: "product1-title", section: "products" },
    { id: "product2-title", section: "products" },
  ];

  const contactInfo = [
    { icon: "fas fa-map-marker-alt", text: "address" },
    { icon: "fas fa-phone", text: "phone" },
    { icon: "fas fa-envelope", text: "email" },
    { icon: "fas fa-clock", text: "hours" },
  ];

  return (
    <footer id="contact">
      <div className="container">
        <div className="footer-content">
          <div className="footer-about">
            <div className="footer-logo">
              <div className="logo-icon">F</div>
              <div className="logo-text">FACIOWARE</div>
            </div>
            <p>{translate("footer-desc")}</p>
          </div>

          <div className="footer-links">
            <h4>{translate("services-label")}</h4>
            <ul>
              {servicesLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={`#${link.section}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.section);
                    }}
                  >
                    {translate(link.id)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-links">
            <h4>{translate("contact-label")}</h4>
            <ul>
              {contactInfo.map((info, index) => (
                <li key={index}>
                  <i className={info.icon}></i>{" "}
                  <span>{translate(info.text)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="copyright">
          <p dangerouslySetInnerHTML={translateHTML("copyright")}></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
